export const state = () =>({
    selected_columns: [ //已選的列表表頭
        { text: "保單號碼", value: "insurance_number" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "業務員", value: "salesman_name", width: "10" , horizontal: "left", virtical: "top", selected: true},
        { text: "投保人姓名", value: "holder_name" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "保險公司", value: "insurance_company_name" , width: "10", horizontal: "left", virtical: "top", selected: true},         
        { text: "產品名稱", value: "insurance_product_name" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "保費", value: "period_fee" , width: "15", horizontal: "right", virtical: "top", selected: true},
        { text: "供款年期", value: "contribution_period" , width: "10", horizontal: "center", virtical: "top", selected: true},
        { text: "投保日期", value: "insured_date" , width: "12", horizontal: "center", virtical: "top", selected: true},
        { text: "受益人姓名", value: "beneficiary_name" , width: "15", horizontal: "left", virtical: "top", selected: true},
    ],
    total_columns: [ //可選的列表表頭
        { text: "保單號碼", value: "insurance_number" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "業務員", value: "salesman_name", width: "10" , horizontal: "left", virtical: "top", selected: true},
        { text: "投保人姓名", value: "holder_name" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "保險公司", value: "insurance_company_name" , width: "10", horizontal: "left", virtical: "top", selected: true},         
        { text: "產品名稱", value: "insurance_product_name" , width: "20", horizontal: "left", virtical: "top", selected: true},
        { text: "保費", value: "period_fee" , width: "15", horizontal: "right", virtical: "top", selected: true},
        { text: "幣別", value: "currency_type" , width: "10", horizontal: "center", virtical: "top", selected: false},
        { text: "供款年期", value: "contribution_period" , width: "10", horizontal: "center", virtical: "top", selected: true},
        { text: "投保日期", value: "insured_date" , width: "12", horizontal: "center", virtical: "top", selected: true},
        { text: "供款期滿日期", value: "effective_date" , width: "12", horizontal: "center", virtical: "top", selected: false},
        { text: "受益人姓名", value: "beneficiary_name" , width: "20", horizontal: "left", virtical: "top",selected: true},
        { text: "被保險人姓名", value: "insured_name" , width: "20", horizontal: "left", virtical: "top",selected: false},
        { text: "第二持有人姓名", value: "second_holder_name" , width: "20", horizontal: "left", virtical: "top", selected: false},
        { text: "後備受保人姓名", value: "backup_holder_name" , width: "20", horizontal: "left", virtical: "top", selected: false},
        { text: "失去行動能力權益人士", value: "loss_of_mobility" , width: "20", horizontal: "left", virtical: "top", selected: false},
        { text: "代理商", value: "agency_company_name" , width: "10", horizontal: "left", virtical: "top", selected: false},
    ],
})

export const getters = {
    getSelectColumns(state){
        var columns = state.selected_columns
        if (columns == null) columns = []
        return state.selected_columns
    },
    getAllColumns: state => state.total_columns
}

export const mutations = {
    setSelectedColumns(state, payload){
        state.selected_columns = payload
    }
}